// extracted by mini-css-extract-plugin
module.exports = {"backButtonStickyWrapper":"Modal_backButtonStickyWrapper_1p8bf","backIcon":"Modal_backIcon_2ql_N"};